import { BroadcastChannel } from "broadcast-channel";

export const paymentChannelName = "ad_panel_payment";

export const isBaleLink = (link?: string) => {
  if (!link) return true;
  const lowercaseLink = link.toLowerCase().trim();
  return lowercaseLink.includes("ble.ir");
};

export const getPaymentBankUrl = (token: string) =>
  `https://sadad.shaparak.ir/VPG/Purchase?token=${token}`;

export type mavizPaymentMessage = {
  key: string;
  url?: string;
  loaded?: boolean;
  close?: boolean;
};

export const safeRedirect = (specs?: string) => {
  const messageKey = `${Date.now()}`;
  window.open(`/redirecting?key=${messageKey}`, "bank", specs);
  const channel = new BroadcastChannel(paymentChannelName);
  const loaded = new Promise((resolve) => {
    channel.addEventListener("message", (message: mavizPaymentMessage) => {
      if (message.key === messageKey && message.loaded) {
        resolve(undefined);
      }
    });
  });

  return {
    onSuccess: (url: string) => {
      loaded.then(() => {
        channel!.postMessage({
          key: messageKey,
          url: url,
        } as mavizPaymentMessage);
      });
    },
    onError: () => {
      loaded.then(() => {
        channel!.postMessage({
          key: messageKey,
          close: true,
        });
      });
    },
  };
};
